module.exports = __webpack_public_path__ + "img/JT_icons01_64px_FAQ.ca6a6825.svg";